export default __webpack_public_path__ + "static/media/WDCM2.34a672a9.jpg";